/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetLinksController } from '../models/AssetLinksController';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetLinksControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a AssetLinksController resource.
     * Retrieves a AssetLinksController resource.
     * @returns AssetLinksController AssetLinksController resource
     * @throws ApiError
     */
    public apiDeepLinkingassetlinksGet(): CancelablePromise<AssetLinksController> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deep-linking/assetlinks/',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
